import { render, staticRenderFns } from "./CaseKeyMetrics.vue?vue&type=template&id=abfefe54&scoped=true"
import script from "./CaseKeyMetrics.vue?vue&type=script&lang=ts"
export * from "./CaseKeyMetrics.vue?vue&type=script&lang=ts"
import style0 from "./CaseKeyMetrics.vue?vue&type=style&index=0&id=abfefe54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfefe54",
  null
  
)

export default component.exports